module.exports = __webpack_public_path__ + "static/media/MB_Landing.faf79102.jpg";